<template>
  <div>
    <component :is="whatItIs" v-if="whatItIs !== 'router-view'"></component>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EquifaxIframeOverlay from '@/components/EquifaxIframeOverlay.vue';

export default {
  data() {
    return {
      iframe: EquifaxIframeOverlay,
    };
  },
  components: {
    EquifaxIframeOverlay,
  },
  computed: {
    ...mapGetters('usCredit', ['getEquifaxIframeQsURL', 'getShouldShowEquifaxIframe']),
    whatItIs() {
      return this.getShouldShowEquifaxIframe ? this.iframe : 'router-view';
    },
  },
};
</script>
<style lang="scss" scoped></style>
